<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow class="justify-content-center">
      <CCol style="width: 600px; min-width: 400px;">
        <CCard>
          <CCardBody>
            <CForm @submit.prevent="resetPassword">
              <h3>KHÔI PHỤC MẬT KHẨU</h3>
              <p class="text-muted">Khôi phục mật khẩu cho tài khoản bị quên mật khẩu</p>
              <CInput
                label="Tài khoản"
                v-model="info.username" required
                autocomplete="account"
                placeholder="Tài khoản"
                horizontal
                :addLabelClasses="'text-right'"
              >
                <template #prepend-content><CIcon name="cil-user"/></template>
              </CInput>
              <CInput
                label="Email"
                v-model="info.email" required
                placeholder="Email"
                autocomplete="email"
                prepend="@"
                horizontal
                :addLabelClasses="'text-right'"
              />
              <CSpinner v-if="loading"></CSpinner>
              <CRow class="align-items-center">
                <CCol></CCol>
                <CCol>
                  <CButton type="submit" color="info" shape="pill"
                           class="mr-1" style="width: 150px">
                            GỬI YÊU CẦU</CButton>
                </CCol>
                <CCol>
                  <CButton type="button" color="secondary" shape="pill"
                           class="mr-1" style="width: 150px"
                           @click="goBack">QUAY LẠI</CButton>
                </CCol>
                <CCol></CCol>
              </CRow>
            </CForm>

            <CRow v-if="errMsg" style="margin-top: 20px" class="justify-content-center">
              <strong style="color:red">{{errMsg}}</strong>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  data() {
    return {
      info: {
        username: '',
        email: '',
        password: 'request',
      },
      errMsg: '',
      loading: false,
    };
  },
  methods: {
    resetPassword() {
      if (this.loading) {
        return;
      }
      this.errMsg = ''
      // console.log('reset password:', this.info);
      this.loading = true;
      this.$request.post('/user/extresetpwd', this.info).then(res=>{
        if(res.data.status === 'success'){
          this.errMsg = "Yêu cầu lấy lại mật khẩu đã được gửi đi, vui lòng kiểm tra email!"
        } else {
          this.errMsg = "Yêu cầu lấy lại mật khẩu lỗi: " + res.data.status;
        }
      }).finally(()=>{
        this.loading = false;
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
